import React, { useState } from "react";
import Modal from "../Modal";
import Button from "components/form/Button";
import RadioInput from "components/form/RadioInput";
import TextArea from "components/form/TextArea";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { objectToFormData } from "utils/helpers";
import { deletePost, showSuccess } from "store/slices";
import { useDispatch } from "react-redux";


const PostDeletePopup = ({ onHide, handelSuccess, postId }) => {
    const [btnLoading, setBtnLoading] = useState()

    const dispatch = useDispatch()
    
    const handleSave = async (values) => {
        setBtnLoading(true)
        const finalReason =
            values?.reason === "Others" ? values?.customReason : values?.reason;

        const formData = objectToFormData({
            post_id: postId,
            key: "delete",
            delete_reason: finalReason,
        });

        const response = await dispatch(deletePost(formData));
        if (response?.status === 200) {
            dispatch(showSuccess(response?.message));
            handelSuccess();
        } else {
            setBtnLoading(false);
        }

    };

    const validationSchema = Yup.object().shape({
        reason: Yup.string().required("Please select a reason"),
        customReason: Yup.string().when("reason", {
            is: "Others",
            then: Yup.string().required("Please enter a custom reason"),
            otherwise: Yup.string().notRequired(),
        }),
    });


    const reasons = [
        "Inappropriate Content",
        "Testing Post",
        "Adult Content",
        "Promotions",
        "Others",
    ];


    return (
        <Modal
            size="md"
            onHide={onHide}
            titleBesideClose="Are you sure want to delete post ?"
            titleBesideCloseClassName={'text-16-400-20'}

            isTitleBorder
            isTitleVerticalCenter
        >
            <Formik
                initialValues={{ reason: "", customReason: "" }}
                validationSchema={validationSchema}
                onSubmit={handleSave}
            >
                {({ values, errors, touched, setFieldValue, handleSubmit }) => (
                    <Form>
                        <div className="cp-20">
                            <p>Please select a reason before deleting this post:</p>

                            {/* Radio Buttons for Reasons */}
                            <div className="d-flex flex-column gap-2 mb-2">
                                {reasons.map((r, i) => (
                                    <RadioInput
                                        key={i}
                                        label={r}
                                        value={r}
                                        name="reason"
                                        onChange={() => setFieldValue("reason", r)}
                                        checked={values.reason === r}
                                    />
                                ))}
                            </div>
                            {errors.reason && touched.reason && (
                                <div className="text-danger small mb-2">{errors.reason}</div>
                            )}

                            {/* If "Others" is selected, show text area */}
                            {values.reason === "Others" && (
                                <div className="mb-3 mt-3">
                                    <TextArea
                                        rows={3}
                                        label="Reason"
                                        placeholder="Enter reason"
                                        value={values.customReason}
                                        error={touched.customReason && errors.customReason}
                                        onChange={(e) =>
                                            setFieldValue("customReason", e.target.value)
                                        }
                                    />
                                </div>
                            )}

                            {/* Action Buttons */}
                            <div className="d-flex align-items-center gap-3 cmt-15">
                                <Button
                                    text="Confirm Delete"
                                    btnStyle="primary-dark"
                                    className="h-35 cps-15 cpe-15"
                                    type="submit"
                                    onClick={handleSubmit}
                                    btnLoading={btnLoading}
                                    disabled={btnLoading}
                                />
                                <Button
                                    text="Cancel"
                                    btnStyle="primary-outline"
                                    className="h-35 cps-15 cpe-15"
                                    onClick={onHide}
                                    disabled={btnLoading}
                                />
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>
        </Modal>
    );
};

export default PostDeletePopup;
